module.exports = __webpack_public_path__ + "static/Group_6252_2x-d7d00796d5e85b1207f190999e10da3b.png";